// extracted by mini-css-extract-plugin
export var cardContainer = "_ok-0";
export var cardHeader = "_ok-2";
export var collapsedState = "_ok-3";
export var dragHandle = "_ok-5";
export var dragHandleIcon = "_ok-6";
export var dragging = "_ok-1";
export var titleArea = "_ok-4";